import React from 'react';
//import axios from 'axios';
import axios from './axios_cg';
import { Button, Modal, Form, Select, Table, Progress } from 'antd';
import $ from 'jquery'
import moment from 'moment';
import './mold.less';

import HomeBottom from './home_public_bottom';
import HomeHeadNavigation from './home_pubilc_head';

import Vector_intelligent_2_img from './static/new_img/Vector_intelligent_2.jpg'
import Vector_intelligent_3_img from './static/new_img/Vector_intelligent_3.jpg'
import Vector_intelligent_4_img from './static/new_img/Vector_intelligent_4.jpg'
import mold_new_1 from './static/new_img/new_1.png'
import mold_new_2 from './static/new_img/new_2.png'
import mold_new_3 from './static/new_img/new_3.png'
import ObsClient from 'esdk-obs-browserjs';


class Mold extends React.Component {
    timer = null;

    // 组件加载完毕 启动定时器
    componentDidMount(){
        setTimeout(this.iTimer,0);
    }


    constructor(props) {
        super(props);
        this.state = {
            OSSAccessKeyId:'',
            AccessKeySecret:'',
            region:'',
            file_path:'',
            bucketName:'',
            policy:'',
            Signature:'',
            key:'',
            token:'',
            bucket_url:'',
            local_select_file:'',
            login_account:'',   //登录用户名(cg 自己的导航栏需要)
            login_account_id:'',//登录用户id
            oss_file_key:'',
            obs_server:'',
            taskID:'',
            table_tasks:[],
            total:0,
            init_pageSize: 6,//每页默认显示的 条目数
            current:1,
            targetVersion:'',
            msg_file:'选择上传文件',
            isDisabled_mold_but:true,
            modal_file:false,
            modal_file_progress:false,
            Progress_percent:'',
            mold_daohang:'',//默认导航栏显示
            oss_max_filename:'',
        };
        this.formRef = React.createRef();
    }


    //定时器
    iTimer = () => {
        this.timer = setInterval(() => {
            //+有条件的刷定时任务
            this.refresh_user_task_data();
        }, 60000);//现在设定为 1分钟刷1次 table数据
    }


    componentWillMount() {
        this.get_is_login();

        //去获取 banner img
        this.img_get_from_redis_mold();

        this.get_banner_data();

        //显示登录用户的转模任务列表
        this.refresh_user_task_data();

        if (this.props.match.path === "/mold"){
            this.but_ok();
        }else{
            this.setState({
                mold_daohang:'none',
            });
            this.xrender_but_ok();
        }
    }


    img_get_from_redis_mold = () =>{
        var url = '/api/img_get_redis_mold_banner/';
        axios.get(url)
        .then((response) => {
            $('#img_图层').attr('src',response.data.result);//首页 banner 从官网中获取
        });
    }


    //banner（图）之外的其他配置
    get_banner_data = () =>{
        var url = '/api/banner_msgs/'
        axios.get(url)
        .then((response) => {
            const mold_data = response.data.rows;
            if (mold_data[1].banner_url === ""){
                $('#mold_banner').attr("href","javascript:;");//href 没有配置,则 不跳转,不回到顶部 (在管理后台上配置)
                $('#mold_banner').attr("target","");
            }else{
                $('#mold_banner').attr("href",mold_data[1].banner_url);//转模页数据
            }
        });
    }


    get_is_login = () =>{
         //判断用户是否登录
        if (this.props.match.path === "/mold"){
            const url = "/api/get_login_msg/";
            axios.get(url).then(response => {
                if (response.data.loginName !== ""){
                    this.setState({
                        login_account:response.data.loginName
                    });
                }else{
                    this.setState({
                        login_account:""
                    });
                }
            });
        }else{
            var str_url = this.props.location.search;         //var str_url = "?userid=100";
            var userid = str_url.replace("?userid=","");
            if (userid == "-1"){
                this.setState({
                    login_account_id:""
                });
            }else{
                this.setState({
                    login_account_id:userid
                },()=>{
                     this.refresh_user_task_data();//xrender 刷数据的地方 (其实最好是和 father_accept_son_msg 一样,让他们登录和登出的时候都告诉我下~ )
                });
            }
        }
    }


    refresh_user_task_data = () =>{
        if (this.props.match.path === "/mold"){
            const url = "/api/get_login_msg/";
            axios.get(url).then(response => {
                if (response.data.loginName !== "" && this.state.login_account !== null){
                    this.setState({
                        login_account:response.data.loginName
                    },()=>{
                        if (this.state.login_account !== "" && this.state.login_account !== null){
                            const url_task = '/api/v1/jobs?page=' + this.state.current + '&count=' + this.state.init_pageSize + '&from_where_submit=web';
                            axios.get(url_task).then(response => {
                                this.setState({
                                    table_tasks: response.data.rows,
                                    total:response.data.total
                                });
                            });
                        }
                    })
                }else{
                    //没有获取到用户信息,则清
                    this.setState({
                        table_tasks:[],
                        total:0
                    });
                }
            });
        }else{
            if (this.state.login_account_id !== "" && this.state.login_account_id !== null){
                 const url_task = '/api/v1/jobs?page=' + this.state.current + '&count=' + this.state.init_pageSize +'&userId='+this.state.login_account_id + '&from_where_submit=web';
                 axios.get(url_task).then(response => {
                     this.setState({
                        table_tasks: response.data.rows,
                        total:response.data.total
                     });
                });
            }else{
                //没有获取到用户信息,则清
                this.setState({
                    table_tasks:[],
                    total:0
                });
            }
        }

        //每次刷新table表后重新将其设置为不可用
        this.setState({
            isDisabled_mold_but:true
        });
    }


    create_task = (file_name,target_version) => {
        if (( this.props.match.path === "/mold" && this.state.login_account !== "")||(this.props.match.path !== "/mold" && this.state.login_account_id !== "")){
            const the_file = document.getElementById('user_max_file').files[0];
            const the_file_size_MB = (the_file.size/ 1024 /1024).toFixed(0);
            if (this.props.match.path === "/mold"){
                var data = {
                    filename:file_name,
                    source_version:'0',
                    target_version:target_version,
                    file_size:the_file_size_MB,
                    from_where_submit:'web',
                    cloud_type:'huawei' // 若不填则用阿里的机器进行转模
                };
            }else{
                var data = {
                    filename:file_name,
                    source_version:'0',
                    target_version:target_version,
                    User:this.state.login_account_id,
                    file_size:the_file_size_MB,
                    from_where_submit:'web',
                    cloud_type:'huawei'
                };
            }

            // 临时sts,调用sdk实现上传
            // V1 新接口
            // 由oss切换到 华为obs上存储
            // https://support.huaweicloud.com/bestpractice-obs/obs_05_1800.html
            axios.post('/api/v1/job',data).then(response => {
                var base_url_buckect = response.data.download_source_url.split("huaweicloud.com/")[0]+"huaweicloud.com/"; // http://cgmagic-test.obs.cn-east-3.myhuaweicloud.com/
                var get_file_key = response.data.download_source_url.replace(base_url_buckect, "")
                var base_url = base_url_buckect.split("//")[1];
                var split_buckect = base_url.split(".")[0];
                var split_region = base_url.split(".")[1];
                var get_file_path = get_file_key.split("/")[0] +'/' +get_file_key.split("/")[1] +'/' +get_file_key.split("/")[2] +'/';

                this.setState({
                    oss_file_key:get_file_key,
                    obs_server:base_url_buckect.replace(split_buckect+'.','').replace('.com/','.com'),
                    taskID:response.data.id.toString(),
                    OSSAccessKeyId:response.data.obs_accessid,
                    AccessKeySecret:response.data.obs_accesskeysecret,
                    token:response.data.obs_securitytoken,
                    region:split_region,
                    file_path:get_file_path,
                    bucketName:split_buckect,
                    oss_max_filename:response.data.filename
                }, ()=>{
                    //重新刷表单数据
                    this.refresh_user_task_data();
                     //开始上传(用sdk实现)
                    this.UploadMaxFile_OssSdk();
                });
            });
        }
    };


    form_reset = () =>{
        this.setState({
            msg_file:"选择上传文件"
        },()=>{
            this.formRef.current.resetFields();//清
        });
    }


    UploadMaxFile_OssSdk = () => {
        this.setState({
          local_select_file: document.getElementById('user_max_file').files[0],
        },
            ()=> {
                // const ObsClient = require('esdk-obs-browserjs');

                // https://support.huaweicloud.com/sdk-browserjs-devg-obs/obs_24_0503.html
                //配置ObsClient参数
                const client = new ObsClient({
                    access_key_id: this.state.OSSAccessKeyId,// ak
                    secret_access_key: this.state.AccessKeySecret,// sk
                    server: this.state.obs_server,// 服务地址 'https://your-endpoint' http://obs.cn-east-3.myhuaweicloud.com
                    security_token: this.state.token,// 临时securityToken
                });
                client.withCredentials = false;

                async function change_putObject (par1,par2,par3,par_this) {
                    try {
                        let mySelf_1 = par_this;

                        var upload_callback = function(transferredAmount, totalAmount, totalSeconds){
                            var percentage = Number((transferredAmount * 100.0 / totalAmount).toString().substring(0,4))
                            if (percentage>0){
                                mySelf_1.setState({
                                    modal_file_progress:true
                                },()=>{
                                    mySelf_1.setState({
                                        Progress_percent: percentage
                                    })
                                });
                            }
                        };

                        await client.putObject({
                            Bucket:par1,
                            Key:par2,
                            SourceFile:par3,
                            ProgressCallback: upload_callback
                        },function (err,result){
                            if(err){
                                console.error('上传err,',err)
                            }else{
                                if(result.CommonMsg.Status === 200){
                                    mySelf_1.upload_success();
                                }else{
                                    mySelf_1.upload_fail();
                                }
                            }
                        })
                    } catch (e) {
                        console.log('异常,',e)
                        //上传失败
                        //par_this.upload_fail();//注意:这里只可以写 par_this！！！
                    }
                }
                change_putObject(
                    this.state.bucketName,
                    this.state.oss_file_key,
                    document.getElementById('user_max_file').files[0],
                    this);
            }
        )
    };


    //上传成功的调用(刷新)
    upload_success = ()=>{
        //max文件上传到oss成功
        this.setState({
            modal_file_progress:false
        },()=>{
            //向转模服务器提交任务
            axios.put('/api/v1/job/'+this.state.taskID+'/submit').then(() => {
                this.refresh_user_task_data();//刷新
            });
            this.form_reset();//清
        });
    }


    //上传失败的调用刷新
    upload_fail = ()=>{
        //max文件上传到oss失败
        this.setState({
            modal_file_progress:false
        });
    }


    task_all = () =>{
        //字段校验
        var file = document.getElementById('user_max_file').files[0];
        if (file ===undefined){
            return
        }
        if (this.state.targetVersion === ""){
            return
        }
        const target_version = this.state.targetVersion;
        //判断文件大小和类型
        const the_file = document.getElementById('user_max_file').files[0];
        const the_file_name = the_file.name
        const the_file_name_lower = the_file_name.toLowerCase()
        const the_file_size_MB = (the_file.size/ 1024 /1024).toFixed(0);
        if (the_file_size_MB < 500){
            if (the_file_name_lower.search(".max") !== -1){
                //建task
                this.create_task(document.getElementById('user_max_file').files[0].name,target_version);

            }else{
                this.setState({
                    isDisabled_mold_but:true
                });
                this.form_reset();
            }
        }else{
            this.setState({
                isDisabled_mold_but:true
            });
            this.form_reset();
        }
    }


    ClickFile = () =>{
        $("#user_max_file").click();
    }


    //每页多少条数据
    changePageSize = (current, pagesize) => {
        this.setState({
            current: 1, //只要改变了 每页的条目数,则默认去拿第1页的 数据//现在定为这样
            init_pageSize: pagesize,
        }, () => {
            this.refresh_user_task_data();
        });
    };


    onClickRow=(record)=> {
        return {
            onClick: () => {
                this.setState({rowId: record.id})
            }
        }
    }


    //请求第几页的数据
    changePage = (page, par2) => {
        this.setState({
            current: page,
        }, () => {
            this.refresh_user_task_data();
        });
    };


    selectVersion = data => {
        if (this.props.match.path === "/mold"){
            this.setState({
                targetVersion:data
            },()=>{
                this.but_ok()
            });
        }else{
            this.setState({
                targetVersion:data
            },()=>{
                this.xrender_but_ok();
            });
        }
    };


    //cg自己的网站判断 转模上传按钮是否可用
    but_ok = () =>{
        if (this.state.msg_file !="选择上传文件" && this.state.targetVersion !="" && this.state.login_account != ""){
            this.setState({
                isDisabled_mold_but:false
            });
        }
    }


    xrender_but_ok =()=>{
         if (this.state.msg_file !="选择上传文件" && this.state.targetVersion !="" && this.state.login_account_id != ""){
             this.setState({
                 isDisabled_mold_but:false
             });
        }
    }


    //监控  input
    selectFile = data => {
        $('#err_tip_file').css('visibility','hidden');

       //判断文件大小和类型
        const the_file = document.getElementById('user_max_file').files[0];

        /*现在为了测试,暂时改掉  */
        const the_file_size_MB = (the_file.size/ 1024 /1024).toFixed(0);
        if (the_file_size_MB > 500){
            this.setState({
                isDisabled_mold_but:true
            });
            this.form_reset();

            this.setState({
                modal_file:true
            });
        }else{
            const full_file_name =  document.getElementById('user_max_file').files[0].name;
            this.setState({
                msg_file:full_file_name
            });
        }
    };


    download_mold_file = data =>{
        const job_url= '/api/v1/job/' + data.id
        axios.get(job_url).then(response => {
            window.location.href =  response.data.signed_target_url;
        });
    }


    handleCancelModal =() => {
        this.setState({
            modal_file:false
        });
    }


    download_client_file = () =>{
        axios.get('/api/download/'
        ).then(response => {
            window.location.href = response.data.version_base;
            axios.get('/api/cg_download/base/');
            this.setState({
                modal_file:false
            });
        })
    }


    //用户登录或登出 都触发 刷新表数据
    father_accept_son_msg =(msg)=>{
        if (msg.action === "登出"){
            this.setState({
                login_account:"",
                isDisabled_mold_but:true,
                login_account_id:""
            },()=>{
                this.refresh_user_task_data();
            });
        }else{
            this.setState({
                login_account_id:msg.login_id
            },()=>{
               this.refresh_user_task_data();
            });
        }
    }


    render() {
        const { Option } = Select;
        const task_columns = [
            {
                title: '文件名',
                dataIndex: 'filename',
                key: 'filename'
            },
            {
                title: '目标版本',
                dataIndex: 'target_version',
                key: 'target_version',
                render: (text, record) => {
                    return '3ds Max'+record.target_version;
                }
            },
            {
                title: '提交时间',
                dataIndex: 'submit_time',
                key: 'submit_time',
                render: (text, record) =>  {
                    return moment(record.submit_time).add('hours',8).format('YYYY-MM-DD HH:mm:ss');//备注: 数据库中记录的时间是 UTC时间. 在页面展示时，(+8)即转化为对应北京时间
                }
            },
            {
                title: '状态',
                dataIndex: 'status',
                key: 'status',
                render: (text, record) => {
                    if (record.is_use_v1_api == 0) {
                        if (record.status == 1) {
                            return "准备中"
                        }else if (record.status == 2) {
                            return "运行中"
                        }else if (record.status == 3) {
                            return "转换完成"
                        }else if (record.status == 4) {
                            return "转换失败"
                        }else if (record.status == 5) {
                            return "已删除"
                        }else if (record.status == 6) {
                            return "上传中"
                        }else if (record.status == 7) {
                            return "上传完成"
                        }else if (record.status == 8) {
                            return "上传失败"
                        }else if (record.status == 9) {
                            return "取消"
                        }
                    }else {
                        //使用的 v1/job 新接口提交的转模任务
                        if (record.status == 1) {
                            return "准备中"
                        } else if (record.status == 2) {
                            return "排队中"
                        } else if (record.status == 3) {
                            return "转模中"
                        } else if (record.status == 4) {
                            return "转模成功"
                        } else if (record.status == 5) {
                            return "转模失败"
                        } else if (record.status == 6) {
                            return "已完成"
                        }
                    }
                }
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, record) => {
                    if (record.is_use_v1_api == 0) {
                        if (record.status == 3) {
                            return <><Button type="primary" className='table_but_style' onClick={() => this.download_mold_file(record)}><span>下载</span></Button></>;
                        }
                    }else{
                        if (record.status == 4 | record.status == 6) {
                            return <><Button type="primary" className='table_but_style' onClick={() => this.download_mold_file(record)}><span>下载</span></Button></>;
                        }
                    }
                    return
                }
            }];

        return(
            <>
                <Modal
                    title="文件异常"
                    closable={true}
                    visible={ this.state.modal_file }
                    centered="true"
                    width="450px"
                    wrapClassName={'max_file_result_style'}
                    onOk={this.download_client_file}
                    onCancel={this.handleCancelModal}
                    okText="下载客户端"
                    cancelText="取消"
                    maskClosable={false}
                    mask={false}
                >
                    <p id="file_too_big_tip">该文件大小超过500M,请下载客户端提交！</p>
                </Modal>

                <Modal
                    title="文件上传"
                    closable={false}
                    visible={ this.state.modal_file_progress }
                    centered="true"
                    width="545px"
                    wrapClassName={'max_file_result_style'}
                    footer={null}
                    mask={false}
                >
                    <p id="file_upload_progress_tip">文件上传过程中请不要刷新页面，关闭此标签及浏览器</p>
                    <Progress
                        strokeColor={{
                            from: '#3390e0',
                            to: '#37edf3',
                        }}
                        percent={this.state.Progress_percent} status="active"
                        type={"line"}
                        trailColor={'#323135'}
                        strokeWidth={"22px"}
                    />
                </Modal>

                {/* 接受子组件传过来的 登录或登出的消息 */}
                <div style={{ display:this.state.mold_daohang }}>
                    <HomeHeadNavigation sou_msg_to_father={(msg)=>{this.father_accept_son_msg(msg)}}/>
                </div>

                {/* 第一部分 src={mold_图层34} */}
                <div id="mold_Header">
                    <a id="mold_banner" target="_blank"><img id="img_图层" alt="text"/></a>
                    <p id='p1'>轻量级版本转换功能</p>
                    <p id='p2'>3ds Max各版本轻松一键转换</p>
                </div>

                {/* 第二部分 */}
                <div id='mold_Setting'>
                    <p className='mold_part_title'>版本转换设置区</p>
                    <div id="part_file_version">
                        <Form layout="inline" ref={this.formRef}>
                            <Form.Item name="user_max_file" rules={[{ required: true, message: '文件必填' }]}>
                                <input type="file" onChange={this.selectFile} accept=".max" />
                            </Form.Item>
                            <Form.Item>
                                <Button id="false_msg" onClick={ this.ClickFile.bind(this)}><span id="msg_span">{ this.state.msg_file  }</span></Button>
                            </Form.Item>
                            <Form.Item>
                                <p id="file_explain">转换为</p>
                            </Form.Item>
                            <Form.Item name="verion_select" rules={[{ required: true, message: '请选择目标版本.' }]}>
                                <Select onChange={this.selectVersion} className="select_style" placeholder="请选择目标版本">
                                    <Option value="2010" className="select_style_in">3ds Max2010</Option>
                                    <Option value="2011" className="select_style_in">3ds Max2011</Option>
                                    <Option value="2012" className="select_style_in">3ds Max2012</Option>
                                    <Option value="2013" className="select_style_in">3ds Max2013</Option>
                                    <Option value="2014" className="select_style_in">3ds Max2014</Option>
                                    <Option value="2015" className="select_style_in">3ds Max2015</Option>
                                    <Option value="2016" className="select_style_in">3ds Max2016</Option>
                                    <Option value="2017" className="select_style_in">3ds Max2017</Option>
                                    <Option value="2018" className="select_style_in">3ds Max2018</Option>
                                    <Option value="2019" className="select_style_in">3ds Max2019</Option>
                                    <Option value="2020" className="select_style_in">3ds Max2020</Option>
                                    <Option value="2021" className="select_style_in">3ds Max2021</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" id='file_mold_but' onClick={this.task_all.bind(this)} disabled={ this.state.isDisabled_mold_but }>
                                    <span>转模上传</span>
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                    <div id="err_tip_file" style={{visibility:'hidden'}}>不是max文件或者文件超过500MB,请重新选择.</div>
                    <div id='mold_Setting_msg_tip'>请先登录再上传需要转换的文件<br />最大支持500MB文件，超过请使用客户端提交</div>

                    {/* 画固定区域:为解决浏览器窗口大小的问题 */}
                    <div id="Setting_fixed">
                        <Table
                            columns={ task_columns }
                            dataSource={ this.state.table_tasks }
                            bordered="false"
                            rowClassName={(record, index) =>
                                index % 2 === 0 ? 'editable-row-ji' : 'editable-row-ou'
                            }
                            pagination={{
                                position:'bottomCenter',
                                showSizeChanger: true,
                                onShowSizeChange: this.changePageSize,
                                current: this.state.current,//当前页数
                                total: this.state.total,
                                onChange: this.changePage,//跳转到 第几页
                                pageSize:6,//指定每页条数 因为不是使用的 默认 10条,so一定要指定
                            }}
                            size="small"
                        />
                    </div>

                    <div id='s_d2'>
                        <p id="s_p3">* 文件下载有效期为3天</p>
                    </div>
                </div>

                {/* 第三部分 */}
                <div id='mold_ProcessGuide'>
                    <div id="ProcessGuide_fixed">
                        <p className='mold_part_title'>流程指南</p>
                        <div id="ProcessGuide_fixed_small_part" className="flex-container">
                            <div id="p_l">
                                <img id='mold_img_01' src={mold_new_1} alt="text"/>
                                <img id='img_m_01' src={Vector_intelligent_2_img} alt="text"/>
                                <p id='pro_l'>上传需要转换的文件</p>
                            </div>
                            <div className="dashed_my_f">
                                <div className="dashed_my"></div>
                                <div className="dashed_my"></div>
                                <div className="dashed_my"></div>
                            </div>
                            <div id="p_m">
                                <img id='mold_img_02' src={mold_new_2} alt="text"/>
                                <img id='img_m_02' src={Vector_intelligent_4_img} alt="text"/>
                                <p id='pro_m'>选择要转的版本</p>
                            </div>
                            <div className="dashed_my_f">
                                <div className="dashed_my"></div>
                                <div className="dashed_my"></div>
                                <div className="dashed_my"></div>
                            </div>
                            <div id="p_r">
                                <img id='mold_img_03' src={mold_new_3} alt="text"/>
                                <img id='img_m_03' src={Vector_intelligent_3_img} alt="text"/>
                                <p id='pro_r'>转换成功后下载文件</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 第四部分 */}
                <div id='mold_CommonProblem'>
                   <div id="CommonProblem_fixed" >
                       <p className='mold_part_title'>常见问题</p>

                       <div id="CommonProblem_fixed_small_part" className="flex-container">
                           <div id="com_l">
                               <div id="left_11">
                                   <p id="que_1" className="com_big">Q:转换版本后的3ds Max文件，打不开是什么原因？</p>
                                   <p id="ans_1" className="com_small">A:可能因为网络传输不稳定导致文件损坏，可以尝试重新下载一下</p>
                               </div>
                               <div id="left_21">
                                   <p id="que_3" className="com_big">Q:提交文件转换版本后如何保存文件？</p>
                                   <p id="ans_3" className="com_small">A:转换任务状态显示已完成后点击下载按钮，选择保存路径，请在</p>
                                   <p id="ans_31" className="com_small">7日有效期内下载</p>
                               </div>
                               <div id="left_31">
                                   <p id="que_5" className="com_big">Q:版本转换以后材质会丢失吗？</p>
                                   <p id="ans_5" className="com_small">A:不会</p>
                               </div>
                           </div>

                           <div id="com_r">
                               <div id="right_11">
                                   <p id="que_2" className="com_big">Q:版本转换器用不了，点提交没反应是怎么回事？</p>
                                   <p id="ans_2" className="com_small">A:可能是浏览器的兼容问题，可以尝试刷新浏览器或者下载客户</p>
                                   <p id="ans_21" className="com_small">端体验</p>
                               </div>
                               <div id="right_21">
                                   <p id="que_4" className="com_big">Q:版本转换需要多长时间？</p>
                                   <p id="ans_4" className="com_small">A:根据你提交的文件版本与目标版本可能需要2至10分钟不等</p>
                               </div>
                               <div id="right_31">
                                   <p id="que_6" className="com_big">Q:版本转换功能支持哪些版本？</p>
                                   <p id="ans_6" className="com_small">
                                       A:最高支持3ds Max 2022转至3ds Max 2010
                                   </p>
                               </div>
                           </div>
                       </div>

                       <div id="CommonProblem_fixed_small_part2"className="flex-container">
                           <div id="number_left" className="number_f">
                               <p id="number1">1</p>
                               <p id="number3">3</p>
                               <p id="number5">5</p>
                           </div>
                           <div id="number_right" className="number_f">
                               <p id="number2">2</p>
                               <p id="number4">4</p>
                               <p id="number6">6</p>
                           </div>
                       </div>
                   </div>
                </div>

                <div style={{ display:this.state.mold_daohang }}>
                    <HomeBottom />
                </div>
            </>
        )
    }
}


export default Mold;

